import { Link } from 'react-router-dom';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEOHead from '@/components/feature/SEOHead';

export default function About() {
  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '妖精漫画网',
    url: 'http://lvtianyuan.com/',
    description: '妖精漫画网是最全的韩国漫画在线阅读平台，提供下拉式韩漫大全、免费漫画在线观看服务。每日更新海量热门韩漫，涵盖浪漫爱情、奇幻冒险、动作热血等多种类型。',
    foundingDate: '2018',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'hello@lvtianyuan.com',
    },
    sameAs: ['http://lvtianyuan.com/'],
  };

  const webPageJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于妖精漫画网',
    description: '了解妖精漫画网 - 最全的韩国漫画在线阅读平台。品牌介绍、发展历程、用户口碑、联系方式。',
    url: 'http://lvtianyuan.com/about',
    isPartOf: {
      '@type': 'WebSite',
      name: '妖精漫画网',
      url: 'http://lvtianyuan.com/',
    },
  };

  return (
    <>
      <SEOHead
        title="关于妖精漫画网_韩国漫画在线阅读平台_品牌介绍与联系方式"
        description="妖精漫画网是最全的韩国漫画在线阅读平台，成立于2018年。提供下拉式韩漫大全、免费漫画在线观看服务。了解我们的品牌故事、发展历程、用户口碑与联系方式。"
        keywords="妖精漫画网,关于妖精漫画,韩国漫画平台,漫画在线阅读,妖精漫画联系方式"
        canonicalUrl="http://lvtianyuan.com/about"
        ogImage="https://readdy.ai/api/search-image?query=Korean%20manhwa%20reading%20community%20banner%2C%20cozy%20library%20atmosphere%2C%20warm%20lighting%2C%20bookshelves%20with%20comics%2C%20modern%20interior%2C%20peaceful%20vibe&width=1200&height=630&seq=og-about&orientation=landscape"
        jsonLd={[orgJsonLd, webPageJsonLd]}
      />

      <main className="pt-20">
        <section className="relative w-full h-[300px] md:h-[400px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20reading%20community%20banner%2C%20cozy%20library%20atmosphere%20with%20warm%20lighting%2C%20bookshelves%20filled%20with%20colorful%20comic%20books%2C%20modern%20interior%20design%2C%20peaceful%20reading%20vibe%2C%20artistic%20composition&width=1400&height=560&seq=about-hero&orientation=landscape"
            alt="妖精漫画网品牌形象"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50" />
          <div className="absolute bottom-0 left-0 right-0 px-4 md:px-6 pb-10">
            <div className="max-w-[1280px] mx-auto">
              <Breadcrumb
                items={[
                  { label: '首页', href: '/' },
                  { label: '关于我们' },
                ]}
              />
              <h1 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-2">
                关于
                <span className="text-accent-500"> 妖精漫画</span>
              </h1>
              <p className="text-sm text-background-50/80 max-w-lg">最全的韩国漫画在线阅读平台</p>
            </div>
          </div>
        </section>

        <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-20">
          <div className="flex flex-col lg:flex-row gap-12">
            <div className="lg:w-2/3">
              <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-4">
                品牌介绍
              </span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">
                十年专注
                <br />
                <span className="text-accent-500">韩漫翻译</span> 与传播
              </h2>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                妖精漫画网成立于2018年，是国内最早专注于韩国漫画翻译与传播的在线平台之一。我们致力于为中国读者带来最新、最全、最高质量的韩国漫画作品，让每一位漫画爱好者都能享受到极致的阅读体验。
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                经过多年的发展，妖精漫画网已经成为国内最具影响力的韩国漫画平台之一，收录了超过10,000部精选韩国漫画作品，涵盖浪漫爱情、奇幻冒险、动作热血、悬疑推理、都市生活、搞笑日常、BL耽美、恐怖惊悚、科幻未来、历史古风等十大类型。
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed mb-6">
                我们的团队由专业的漫画翻译人员、编辑和技术人员组成，秉承&ldquo;品质至上、用户第一&rdquo;的理念，为每一位读者提供流畅的下拉式阅读体验和丰富的漫画内容。
              </p>

              <div className="flex flex-wrap gap-3 mb-10">
                <Link to="/" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                  浏览漫画 <i className="ri-arrow-right-line"></i>
                </Link>
                <a href="#contact" className="inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-primary-500 text-primary-500 text-sm font-medium hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer">
                  联系我们 <i className="ri-mail-line"></i>
                </a>
              </div>
            </div>

            <div className="lg:w-1/3">
              <div className="relative rounded-lg overflow-hidden aspect-[3/4]">
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20artist%20working%20at%20desk%2C%20professional%20illustrator%20studio%2C%20warm%20natural%20lighting%20from%20window%2C%20clean%20modern%20workspace%2C%20creative%20atmosphere%2C%20artistic%20composition%2C%20beautiful%20mood&width=600&height=800&seq=about-founder&orientation=portrait"
                  alt="妖精漫画创作团队"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-100/70 py-14 md:py-20">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 mb-4">
                用户口碑
              </span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
                来自读者的
                <span className="text-accent-500"> 真实评价</span>
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-background-50 rounded-lg p-6 border border-background-200/70">
                <div className="flex items-center gap-1 mb-3">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <i key={star} className="ri-star-fill text-accent-500 text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  &ldquo;妖精漫画网真的是我用过最好的韩漫平台！更新速度超快，翻译质量也很高，下拉式阅读体验太舒服了。已经推荐给身边所有喜欢韩漫的朋友了！&rdquo;
                </p>
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-background-200"></div>
                  <div>
                    <p className="text-xs font-semibold text-foreground-800">小甜饼</p>
                    <p className="text-[10px] text-foreground-400">资深韩漫读者 · 3年用户</p>
                  </div>
                </div>
              </div>

              <div className="bg-background-50 rounded-lg p-6 border border-background-200/70">
                <div className="flex items-center gap-1 mb-3">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <i key={star} className="ri-star-fill text-accent-500 text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  &ldquo;漫画种类太全了！从浪漫爱情到悬疑推理，各种类型都有。界面也很干净，没有乱七八糟的广告，阅读体验一级棒。这个韩漫网真的太良心了！&rdquo;
                </p>
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-background-200"></div>
                  <div>
                    <p className="text-xs font-semibold text-foreground-800">漫画老司机</p>
                    <p className="text-[10px] text-foreground-400">漫画博主 · 5年用户</p>
                  </div>
                </div>
              </div>

              <div className="bg-background-50 rounded-lg p-6 border border-background-200/70">
                <div className="flex items-center gap-1 mb-3">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <i key={star} className="ri-star-fill text-accent-500 text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  &ldquo;每天必刷的漫画网站！更新列表一目了然，收藏功能也很方便。最喜欢的几部韩漫都在这里追，下拉式阅读真的太适合手机看了。&rdquo;
                </p>
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-background-200"></div>
                  <div>
                    <p className="text-xs font-semibold text-foreground-800">追漫少女</p>
                    <p className="text-[10px] text-foreground-400">大学生 · 1年用户</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-20">
          <div className="text-center mb-10">
            <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-4">
              核心优势
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              为什么选择
              <span className="text-accent-500"> 妖精漫画网</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-foreground-900 rounded-lg p-6 text-center">
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-500">
                <i className="ri-database-2-line text-background-50 text-2xl"></i>
              </div>
              <h3 className="text-base font-semibold text-background-50 mb-2 font-heading">资源丰富</h3>
              <p className="text-xs text-background-50/70 leading-relaxed">
                收录超过10,000部精选韩国漫画，覆盖十大热门类型，每日更新量超过200话，确保你最全的韩漫阅读体验。
              </p>
            </div>

            <div className="bg-background-50 rounded-lg p-6 text-center border border-background-200/70">
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-500">
                <i className="ri-flashlight-line text-background-50 text-2xl"></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2 font-heading">更新及时</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                专业翻译团队7x24小时待命，热门作品同步韩国更新，绝不让你错过任何精彩剧情。快速翻译，品质保证。
              </p>
            </div>

            <div className="bg-background-50 rounded-lg p-6 text-center border border-background-200/70">
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-500">
                <i className="ri-emotion-happy-line text-background-50 text-2xl"></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2 font-heading">免费观看</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                所有漫画完全免费在线观看，无需注册即可畅读。支持下拉式阅读模式，流畅的翻页体验让你沉浸其中。
              </p>
            </div>
          </div>
        </section>

        <section id="contact" className="bg-background-100/70 py-14 md:py-20">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="max-w-2xl mx-auto text-center">
              <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 mb-4">
                联系我们
              </span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
                与妖精漫画
                <span className="italic font-normal text-accent-500"> 取得联系</span>
              </h2>
              <p className="text-sm text-foreground-500 mb-10">
                有任何问题、建议或合作意向，欢迎随时联系我们
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-10">
                <div className="bg-background-50 rounded-lg p-5 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3 mx-auto">
                    <i className="ri-mail-line text-lg"></i>
                  </div>
                  <p className="text-xs font-medium text-foreground-700 mb-1">电子邮箱</p>
                  <p className="text-xs text-foreground-500">hello@lvtianyuan.com</p>
                </div>
                <div className="bg-background-50 rounded-lg p-5 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-3 mx-auto">
                    <i className="ri-wechat-line text-lg"></i>
                  </div>
                  <p className="text-xs font-medium text-foreground-700 mb-1">微信公众号</p>
                  <p className="text-xs text-foreground-500">妖精漫画网</p>
                </div>
                <div className="bg-background-50 rounded-lg p-5 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mb-3 mx-auto">
                    <i className="ri-customer-service-2-line text-lg"></i>
                  </div>
                  <p className="text-xs font-medium text-foreground-700 mb-1">客服支持</p>
                  <p className="text-xs text-foreground-500">在线客服 9:00-22:00</p>
                </div>
              </div>

              <Link
                to="/"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                返回首页开始阅读 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}